import { render, staticRenderFns } from "./RoundFormCard.vue?vue&type=template&id=5b2faebc&scoped=true&"
import script from "./RoundFormCard.vue?vue&type=script&lang=js&"
export * from "./RoundFormCard.vue?vue&type=script&lang=js&"
import style0 from "./RoundFormCard.vue?vue&type=style&index=0&id=5b2faebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2faebc",
  null
  
)

export default component.exports